import { SubjectManager } from "../utils/subject-manager";

export const dashboardMapEventsService = new SubjectManager();
